(function(){
  var MONTHS=['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
  var DOWS=['Lun','Mar','Mer','Jeu','Ven','Sam','Dim'];
  function init(){
    var root=document.querySelector('[data-cal]'); if(!root) return;
    var grid=root.querySelector('[data-cal-grid]'), label=root.querySelector('[data-cal-month]');
    var dows=root.querySelector('[data-cal-dows]'), out=document.querySelector('[data-date-out]');
    var hidden=document.querySelector('[data-date-input]');
    var now=new Date(), view={y:now.getFullYear(),m:now.getMonth()}, sel=null;
    dows.innerHTML=DOWS.map(function(d){return '<div>'+d+'</div>';}).join('');
    function pad(n){return n<10?'0'+n:''+n;}
    function render(){
      label.textContent=MONTHS[view.m].charAt(0).toUpperCase()+MONTHS[view.m].slice(1)+' '+view.y;
      var first=new Date(view.y,view.m,1), start=(first.getDay()+6)%7;
      var days=new Date(view.y,view.m+1,0).getDate();
      var today=new Date(); today.setHours(0,0,0,0);
      var html='';
      for(var i=0;i<start;i++) html+='<div class="empty"></div>';
      for(var d=1;d<=days;d++){
        var key=view.y+'-'+pad(view.m+1)+'-'+pad(d);
        var dt=new Date(view.y,view.m,d);
        var cls=dt<today?'past':(key===sel?'sel':'');
        html+='<div class="'+cls+'" data-key="'+key+'">'+d+'</div>';
      }
      grid.innerHTML=html;
    }
    grid.addEventListener('click',function(e){
      var c=e.target.closest('[data-key]'); if(!c||c.classList.contains('past')) return;
      sel=c.getAttribute('data-key'); render();
      var p=sel.split('-');
      var pretty=parseInt(p[2],10)+' '+MONTHS[parseInt(p[1],10)-1]+' '+p[0];
      if(out) out.textContent=pretty;
      if(hidden) hidden.value=pretty;
    });
    root.querySelector('[data-cal-prev]').addEventListener('click',function(){view.m--;if(view.m<0){view.m=11;view.y--;}render();});
    root.querySelector('[data-cal-next]').addEventListener('click',function(){view.m++;if(view.m>11){view.m=0;view.y++;}render();});
    render();
    var burger=document.querySelector('[data-burger]');
    if(burger) burger.addEventListener('click',function(){document.querySelector('[data-nav]').classList.toggle('open');});
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
})();